import { Location } from '@cobliteam/common-types';

import { lazy } from '@cobliteam/lazy-with-retries';

const IntegrationsAppsPage = lazy(() => import('@cobliteam/integrations/src/components/Apps/AppsPage'));
const IntegrationsCustomizationsPage = lazy(() => import('@cobliteam/integrations/src/components/Customizations/CustomizationsPage'));
const IntegrationsApisPage = lazy(() => import('@cobliteam/integrations/src/components/Apis/ApisPage'));
const IntegrationsDocumentationPage = lazy(() => import('@cobliteam/integrations/src/components/Documentation/DocumentationPage'));
const IntegrationsWebhooksPage = lazy(() => import('@cobliteam/integrations/src/components/Webhooks/WebhooksPage'));
const IntegrationsMovedFromSettingsPage = lazy(() => import('@cobliteam/integrations/src/components/MovedFromSettings/MovedFromSettingsPage'));

const routes = [
  {
    path: Location.APPS,
    team: 'squad-gf-core',
    component: IntegrationsAppsPage,
    accessDeniedDescription: 'ver integrações com a Cobli',
  },
  {
    path: Location.CUSTOMIZATIONS,
    team: 'squad-gf-core',
    component: IntegrationsCustomizationsPage,
    accessDeniedDescription: 'ver integrações com a Cobli',
  },
  {
    path: Location.DOCUMENTATION,
    team: 'squad-gf-core',
    component: IntegrationsDocumentationPage,
    accessDeniedDescription: 'ver integrações com a Cobli',
  },
  {
    path: Location.APIS,
    team: 'squad-gf-core',
    component: IntegrationsApisPage,
    accessDeniedDescription: 'ver integrações com a Cobli',
  },
  {
    path: Location.WEBHOOKS,
    team: 'squad-gf-core',
    component: IntegrationsWebhooksPage,
    accessDeniedDescription: 'ver integrações com a Cobli',
  },
  {
    path: Location.CONFIG_INTEGRATIONS,
    team: 'squad-gf-core',
    component: IntegrationsMovedFromSettingsPage,
    accessDeniedDescription: 'ver integrações com a Cobli',
  },
];

export default routes;
